module.exports = __webpack_public_path__ + "img/leijun.5e618c43.jpg";